var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoho2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4900",
    "data-name": "Rectangle 4900",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.372,
    y1: 1.12,
    x2: -4.331,
    y2: 1.12,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d92231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba2234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.006,
    y1: 2.864,
    x2: 0.002,
    y2: 2.864,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.005,
    y1: 1.005,
    x2: 0.003,
    y2: 1.005,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zoho_2",
    "data-name": "Zoho 2",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8723",
    "data-name": "Group 8723",
    transform: "translate(63.48 480.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8725",
    "data-name": "Group 8725",
    transform: "translate(0.116 0.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11249",
    "data-name": "Path 11249",
    d: "M108.987,5.417l.9-4.814a.126.126,0,0,1,.249,0l1.992,13.337v.043l-.908,4.689a.126.126,0,1,1-.247-.048l.9-4.668L110,1.386l-.762,4.077a.126.126,0,1,1-.248-.046Z",
    transform: "translate(-95.319 -0.5)",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11250",
    "data-name": "Path 11250",
    d: "M.729,7.489,1.976,2.756l.1-.092L15.378.5a.126.126,0,0,1,.04.249L2.2,2.9.973,7.553a.126.126,0,0,1-.244-.064Z",
    transform: "translate(-0.706 -0.5)",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11251",
    "data-name": "Path 11251",
    d: "M14.347,38.6l.125-.019,2.023,13.347L2.784,54.076.575,40.591,14.452,38.46l.019.125-.125.019.019.125L.865,40.8,2.992,53.788l13.215-2.066-1.985-13.1.125-.019.019.125Z",
    transform: "translate(-0.575 -33.674)",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11252",
    "data-name": "Path 11252",
    d: "M40.281,70.793l3.869-.605a.389.389,0,0,1,.407.21,1.805,1.805,0,0,1-.311,2.031c-.009.011-.018.022-.028.032-.21.217-2.694,2.835-2.646,4.889a.39.39,0,0,0,.453.38l3.888-.661",
    transform: "translate(-35.276 -61.399)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho2);
export default __webpack_public_path__ + "static/media/Zoho2.f68ae4d7336d0c041260db3752298a52.svg";
export { ForwardRef as ReactComponent };